import { Directive, ElementRef, HostListener, Renderer2, OnInit, inject } from '@angular/core';
import { ClosuresService } from '@riise/core/services/closures/closures.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';



@Directive({
  selector: 'input[type=date][appClosure]'
})

export class ClosureDirective implements OnInit {

  private el = inject(ElementRef);
  private renderer = inject(Renderer2);
  private closuresService = inject(ClosuresService);
  private snackBar = inject(MatSnackBar);
  private translateService = inject(TranslateService);



  constructor() {}



  ngOnInit(): void {
    const cloture = this.closuresService.getCloture();
    if (cloture) {
      const formattedDate = cloture.toISOString().split('T')[0];
      this.renderer.setAttribute(this.el.nativeElement, 'min', formattedDate);
      if (!this.el.nativeElement.value) {
        this.renderer.setProperty(this.el.nativeElement, 'value', '');
      }
    }
  }



  // Utilise 'blur' pour laisser l'utilisateur saisir toute la valeur avant vérification
  @HostListener('blur')
  @HostListener('change')
  onEvent(): void {

    // Si l'élément est toujours focus, on ne valide pas
    if (document.activeElement === this.el.nativeElement) {
      return;
    }

    const inputValue: string = this.el.nativeElement.value;
    if (!inputValue) return;

    // Si la saisie n'est pas complète (attendu: 10 caractères pour "YYYY-MM-DD"), on ne valide pas
    if (inputValue.trim().length !== 10) {
      return;
    }

    const inputDate = new Date(inputValue);

    if (this.closuresService?.blockedDate(inputDate)) {
        this.renderer.setProperty(this.el.nativeElement, 'value', '');
        const errorMsg = this.translateService.instant("La date saisie est égale à la date de clôture");
        this.snackBar.open(errorMsg, "OK", { duration: 10000 });
    }
  }
}
